import React from 'react';
import Packages from './Packages';

const PackagesPage = () => {
  return (
    <section className="packages-page">
      <div className="container">
        <Packages />
      </div>
    </section>
  );
};

export default PackagesPage;

